var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataTables_paginate paging_simple_numbers"},[_c('ul',{staticClass:"pagination pagination-rounded mb-0"},[_c('b-pagination',{staticClass:"m-0",attrs:{"total-rows":_vm.totalRows,"per-page":_vm.perPage},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }